import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import IconButton from '@scalero-inc/forno-icon-button';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var classNamePrefix = 'forno-modal';
var statuses = ['normal', 'danger', 'warning'];
var themes = ['dark', 'light'];

function getIcon(status, icon) {
  if (icon) return icon;

  switch (status) {
    case 'danger':
      return FiAlertTriangle;

    default:
      return null;
  }
}

function Header(_ref) {
  var status = _ref.status,
      icon = _ref.icon,
      title = _ref.title,
      onDismiss = _ref.onDismiss,
      theme = _ref.theme;
  var Icon = getIcon(status, icon);
  return /*#__PURE__*/jsxs("header", {
    className: "".concat(classNamePrefix, "-header font-block-l-sb"),
    children: [/*#__PURE__*/jsxs("div", {
      className: "".concat(classNamePrefix, "-header-title-wrapper"),
      children: [Icon ? /*#__PURE__*/jsx(Icon, {
        className: "".concat(classNamePrefix, "-header-title-icon")
      }) : null, title ? /*#__PURE__*/jsx("h2", {
        className: "".concat(classNamePrefix, "-header-title font-block-l-sb"),
        children: title
      }) : null]
    }), /*#__PURE__*/jsx(IconButton, {
      className: "".concat(classNamePrefix, "-closing-button"),
      size: "m",
      onClick: onDismiss,
      hierarchy: "tertiary",
      theme: theme,
      children: /*#__PURE__*/jsx(FiX, {})
    })]
  });
}

Header.propTypes = {
  status: PropTypes.oneOf(['warning', 'success', 'info', 'danger']),
  title: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  icon: PropTypes.func,
  theme: PropTypes.oneOf(themes)
};
Header.defaultProps = {
  title: null,
  status: 'info',
  icon: null,
  theme: 'light'
};

function Content(_ref) {
  var children = _ref.children;
  var customClassName = classNames("".concat(classNamePrefix, "-content"), 'font-paragraph-s');
  return /*#__PURE__*/jsx("section", {
    className: customClassName,
    children: children
  });
}

Content.propTypes = {
  children: PropTypes.node
};
Content.defaultProps = {
  children: null
};

function Footer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx("footer", {
    className: "".concat(classNamePrefix, "-footer"),
    children: children
  });
}

Footer.propTypes = {
  children: PropTypes.node.isRequired
};
Footer.defaultProps = {};

var _excluded = ["theme", "status", "isOpen", "onDismiss", "dangerouslyBypassFocusLock", "children", "className"];

function Modal(_ref) {
  var theme = _ref.theme,
      status = _ref.status,
      isOpen = _ref.isOpen,
      onDismiss = _ref.onDismiss,
      dangerouslyBypassFocusLock = _ref.dangerouslyBypassFocusLock,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var customClassName = classNames("".concat(classNamePrefix, "-container"), className);
  return /*#__PURE__*/jsx(DialogOverlay, {
    className: "".concat(classNamePrefix, "-backdrop"),
    isOpen: isOpen,
    onDismiss: onDismiss,
    dangerouslyBypassFocusLock: dangerouslyBypassFocusLock,
    "data-theme": theme,
    "data-status": status,
    children: /*#__PURE__*/jsx(DialogContent, _objectSpread2(_objectSpread2({
      className: customClassName
    }, rest), {}, {
      children: children
    }))
  });
}

Modal.propTypes = {
  status: PropTypes.oneOf(statuses),
  theme: PropTypes.oneOf(themes),
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  dangerouslyBypassFocusLock: PropTypes.bool
};
Modal.defaultProps = {
  className: null,
  status: 'normal',
  theme: 'light',
  isOpen: false,
  dangerouslyBypassFocusLock: false
};
Modal.Header = Header;
Modal.Content = Content;
Modal.Footer = Footer;

export { Modal as default };
